module.exports = "/call-frontend/img/signup-bottom.8a29896c.png";